import { render, staticRenderFns } from "./ivr-filter.vue?vue&type=template&id=739a6e35"
import script from "./ivr-filter.vue?vue&type=script&lang=js"
export * from "./ivr-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports